<template>
  <li class="selected-filter">
    <span class="selected-filter__name">
      <slot />
    </span>
    <img
      class="selected-filter__icon"
      src="~/assets/icons/cross-colored.svg"
      alt="remove"
    />
  </li>
</template>

<style lang="scss" scoped>
.selected-filter {
  @include flex-container(row, space-between, center);
  gap: 4px;

  outline: 1px solid var(--color-primary-base);
  border-radius: 30px;

  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  padding: 4px 8px;

  cursor: pointer;

  &__name {
    @include font(12, 14, 500);
    color: var(--color-primary-base);
  }

  &__icon {
    @include fixedHW(16px);
  }
}
</style>
